import axios from "axios";

export default function getGlobalSlaConfigs() {
  return new Promise((resolve, reject) =>
    axios
      .get("/support/api/v1/admin/sla-global-configs")
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
